import { useState } from "react";
import { useLocation } from "react-router-dom";

const logo_handyman = require("./images/MATANATO_LOGO.PNG");

const Nav = () => {
  const location = useLocation();
  const [state, setState] = useState(false);

  return (
    <nav className="bg-white w-full border-b md:border-0 md:static">
      <div className="items-center px-4 max-w-screen-xl mx-auto md:flex md:px-8">
        <div className="flex items-center justify-between py-3 md:py-5 md:block">
          <a href="/handyman">
            <img
              fetchpriority="low"
              src={logo_handyman}
              width={70}
              height={50}
              alt="Float UI logo"
              className="shadow-2xl rounded-lg"
            />
          </a>
          <div className="md:hidden">
            <button
              className="text-gray-700 outline-none p-2 rounded-md focus:border-gray-400 focus:border"
              onClick={() => setState(!state)}
            >
              {state ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 8h16M4 16h16"
                  />
                </svg>
              )}
            </button>
          </div>
        </div>
        <div
          className={`flex-1 justify-self-center pb-3 mt-8 md:block md:pb-0 md:mt-0 ${
            state ? "block" : "hidden"
          }`}
        >
          <ul className="justify-left sm:ml-5 space-y-8 md:flex md:space-x-6 md:space-y-0">
            <li
              onClick={() => setState(!state)}
              className="text-gray-600 hover:text-sky-600  font-semibold"
            >
              <a href="#benefits">Benefits</a>
            </li>
            <li
              onClick={() => setState(!state)}
              className="text-gray-600 hover:text-sky-600  font-semibold"
            >
              <a href="#prices">Prices</a>
            </li>

            <li
              onClick={() => setState(!state)}
              className="text-gray-600 hover:text-sky-600  font-semibold"
            >
              <a href="#faq_handyman">FAQ</a>
            </li>

            <li
              onClick={() => setState(!state)}
              className="text-gray-600 hover:text-sky-600  font-semibold"
            >
              <a href="#contact_handyman">Contact</a>
            </li>

            <li className="text-gray-600 hover:text-sky-600  font-semibold">
                        <a href="./">
                            Home
                        </a>
                    </li>
            {
              
                        location.pathname === "/handyman" ? 
                        <li className="text-gray-600 hover:text-sky-600  font-semibold">
                        <a href="/services">
                            Services
                        </a>
                    </li> :
                    <li className="text-gray-600 hover:text-sky-600  font-semibold">
                    <a href="/handyman">
                        For handyman
                    </a>
                </li>
                    
                  }
          </ul>
        </div>

        <div className="hidden md:block mt-5 mb-7 md:mt-0 md:mb-0">
          <a
            onClick={() => setState(!state)}
            href="#hire"
            className="py-3 px-4 text-white bg-sky-600 hover:bg-sky-700 rounded-md shadow"
          >
            Registration form
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Nav;
